import Vue from 'vue'
//引入需要的组件
import { Button, Field, Popup, Swipe, SwipeItem, Uploader, Picker, Toast, Pagination, empty, Cascader, search   } from 'vant'
import { Nodata } from 'vant-green'
//一定要注册组件
Vue.use(Field)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Pagination)
Vue.use(empty)
Vue.use(Picker)
Vue.use(Cascader)
Vue.use(Toast)
Vue.use(search)
Vue.use(Nodata)
Vue.use(Swipe).use(SwipeItem)
